import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ModalConfirmLogoutService {
  private isOpenSubject = new BehaviorSubject<boolean>(false);
  private isClosingSubject = new BehaviorSubject<boolean>(false);
  isOpen$ = this.isOpenSubject.asObservable();
  isClosing$ = this.isClosingSubject.asObservable();

  constructor() { }

  toggleModal(value?: boolean): void {
    const newValue = value !== undefined ? value : !this.isOpenSubject.value;

    // Si estamos cerrando el modal, primero activamos la animación de cierre
    if (this.isOpenSubject.value === true && newValue === false) {
      this.isClosingSubject.next(true);

      // Después de un tiempo para la animación, cerramos el modal
      setTimeout(() => {
        this.isOpenSubject.next(false);
        this.isClosingSubject.next(false);
      }, 300); // 300ms para coincidir con la duración de la animación CSS
    } else {
      // Si estamos abriendo el modal, lo hacemos inmediatamente
      this.isOpenSubject.next(newValue);
      this.isClosingSubject.next(false);
    }
  }

  get isOpen(): boolean {
    return this.isOpenSubject.value;
  }
}
